import { api } from './client';

export const getUsers = async () => {
    const result = await api.get(`/users`);
    return result.data;
}

export const updateUser = async (user) => {
    await api.put(`/users/${user.id}`, user);
};